class R13GroupedCartItem extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.lines = this.parseLines();
    this.cart = document.querySelector('cart-drawer');
    this.error = this.querySelector('[data-r13-grouped-error]');

    this.querySelectorAll('[data-r13-grouped-action]').forEach((button) => {
      button.addEventListener('click', () => this.update(button.dataset.r13GroupedAction));
    });
  }

  parseLines() {
    try {
      return JSON.parse(this.querySelector('[data-r13-grouped-lines]')?.textContent || '[]');
    } catch (error) {
      console.warn('Unable to parse grouped cart lines', error);
      return [];
    }
  }

  getUpdates(action) {
    if (!this.lines.length) return {};
    if (action === 'remove') return Object.fromEntries(this.lines.map((line) => [line.key, 0]));

    const line = action === 'decrease' ? this.lines[this.lines.length - 1] : this.lines[0];
    const change = action === 'decrease' ? -1 : 1;
    return { [line.key]: Math.max(0, Number(line.quantity) + change) };
  }

  async update(action) {
    const updates = this.getUpdates(action);
    if (!Object.keys(updates).length) return;

    this.toggleAttribute('aria-busy', true);
    this.querySelectorAll('button').forEach((button) => { button.disabled = true; });
    if (this.error) this.error.textContent = '';

    try {
      const sections = this.cart?.getSectionsToRender?.().map((section) => section.id) || [];
      const response = await fetch(window.routes?.cart_update_url || '/cart/update.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ updates, sections, sections_url: window.location.pathname }),
      });
      const cartData = await response.json();
      if (!response.ok || cartData.status) throw new Error(cartData.description || cartData.message || 'Unable to update the cart.');

      if (window.PUB_SUB_EVENTS && typeof window.publish === 'function') {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
          source: 'r13-grouped-cart-item',
          cartData,
        });
      }
      this.cart?.renderContents?.(cartData);
    } catch (error) {
      if (this.error) this.error.textContent = error.message || 'Unable to update the cart. Please try again.';
      this.removeAttribute('aria-busy');
      this.querySelectorAll('button').forEach((button) => { button.disabled = false; });
    }
  }
}

if (!customElements.get('r13-grouped-cart-item')) {
  customElements.define('r13-grouped-cart-item', R13GroupedCartItem);
}
